import PlorbinPic from './PlorbinPic'
import PlorbinText from './PlorbinText'

import consoleImage from './utils/consoleImage'
import pageAccessedByReload from './utils/pageAccessedByReload'

import './Plorbin.css'

function Plorbin() {
  // `consoleOutput()` writes goofy text
  // and images to the dev console 
  const consoleOutput = () => {
    const randomIP = (Math.floor(Math.random() * 255) + 1)+"."+(Math.floor(Math.random() * 255))+"."+(Math.floor(Math.random() * 255))+"."+(Math.floor(Math.random() * 255))
    consoleImage("https://t3.ftcdn.net/jpg/00/71/14/04/360_F_71140435_A4kGltL08ggcZeSShPvrWdX8hk61Qr3R.jpg")
    console.log('%cplorb in plorb IP:','color:black; background-color:red; font-size:1.5em; font-weight:bold; font-family:monospace; padding: 10px;')
    console.log(`%c🚨 ${randomIP} 🚨`,'color:red; background-color:black; font-size:2em; font-weight:bold; padding: 10px;')
  }


  // `refreshCounter()` is loaded on each render
  // and updates the number of times the page is
  // visited, displaying it in the top right
  // OR display discord invite link
  const refreshCounter = () => {
    // on first visit, create 'reload-count' in localStorage
    // on subsequent visits, reload-count++
    if (pageAccessedByReload & !localStorage.getItem('reloadCount')) {
      localStorage.setItem('reloadCount', 0)
    } else if (pageAccessedByReload) {
      localStorage.setItem('reloadCount', Number(localStorage.getItem('reloadCount')) + 1)
    }

    // engaged visitors receive discord server invite
    let reloads = localStorage.getItem('reloadCount')
    if (Number(reloads) >= 50) {
      return <div id="reloads"><a href="https://discord.gg/6DCeR22JEg">plorbin.</a></div>
    }

    return <div id="reloads" className="no-link">{reloads}</div>
  }


  // `generateContent()` returns <PlorbinPic /> 
  // 1% of the time, or returns <PlorbinText />
  const generateContent = () => {
    const usePicture = Math.random() >= 0.99

    if (usePicture) {
      console.log('%chehe made by sillypilled :P','color:pink;font-family:cursive')
      return PlorbinPic()
    }
    else {
      consoleOutput()
      return PlorbinText()
    }
  }


  return (
    <div className="plorbin">
      <div className="plorbin-content">
        {refreshCounter()}
        {generateContent()}
      </div>
    </div>
  )
}


export default Plorbin